import { render, staticRenderFns } from "./ChildSettingsPanelsItem.vue?vue&type=template&id=182db6fc&scoped=true&"
import script from "./ChildSettingsPanelsItem.vue?vue&type=script&lang=js&"
export * from "./ChildSettingsPanelsItem.vue?vue&type=script&lang=js&"
import style0 from "./ChildSettingsPanelsItem.vue?vue&type=style&index=0&id=182db6fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182db6fc",
  null
  
)

export default component.exports